export default __webpack_public_path__ + "static/gift-card-7.url-b0538b71b8c74811c870532e4205816b.svg";